// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c1aabac7","520":"9048d540","787":"a6f3efed"}[chunkId] + ".chunk.js";
};